import React from 'react';
export function FooterLinkSection() {
  return <div className="text-center pt-8" data-id="element-3223">
      <a href="/WhatIsHighSpeedMachining.html" className="inline-block text-2xl font-bold text-orange hover:text-navy hover:underline transition-colors" data-id="element-3224">
        See The Full Mikron High-Speed Line Up
      </a>
    </div>;
}